import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
@Component({
  // tslint:disable-next-line
  selector: "body",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent {
  constructor(
    private router: Router,
    translate: TranslateService,
    public http: HttpClient,
  ) {
    translate.setDefaultLang("default");
    localStorage.setItem("loader_counter", "0");
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    const lastActivity = new Date(
      parseInt(localStorage.getItem("LAST_ACTIVITY") || "0", 10),
    ).getTime();
    if (new Date().getTime() - lastActivity > 1000 * 60 * 15) {
      localStorage.clear();
      localStorage.setItem("LAST_ACTIVITY", new Date().getTime().toString());
      location.href = location.origin;
    }
    window.setInterval(
      () => {
        this.checkBrowser();
      },
      1000 * 60 * 1,
    );
    this.checkBrowser();
  }

  checkBrowser() {
    this.http
      .get(location.origin, { responseType: "text" })
      .subscribe((html) => {
        const el = document.createElement("html");
        el.innerHTML = html;
        const scripts = el.getElementsByTagName("script");
        for (let index = 0; index < scripts.length; index++) {
          const element = scripts[index];
          this.http.head(element.src + "").subscribe(
            () => {},
            () => {
              location.href = location.href;
            },
          );
        }
      });

    localStorage.setItem("LAST_ACTIVITY", new Date().getTime().toString());
  }
}
